import "./i18n";
import "./index.css";
import { mountClientApp } from "@/app/bootstrapClient";

mountClientApp();